var language = 'zh-CN';
if (window.location.search.indexOf('locale=USA') > -1) {
  language = 'USA';
  localStorage.setItem('language',language);
} else if(window.location.search.indexOf('locale=en') > -1){
  language = 'USA';
  localStorage.setItem('language',language);
} else if (window.location.search.indexOf('locale=JP') > -1) {
  language = 'JP';
  localStorage.setItem('language',language);
} else if (window.location.search.indexOf('locale=KO') > -1) {
  language = 'KO';
  localStorage.setItem('language',language);
} else if (window.location.search.indexOf('locale=TH') > -1) {
  language = 'TH';
  localStorage.setItem('language',language);
} else if (window.location.search.indexOf('locale=zh-CN') > -1) {
  language = 'zh-CN';
  localStorage.setItem('language',language);
} else if (window.location.search.indexOf('locale=YH') > -1) {
  language = 'YH';
  localStorage.setItem('language',language);
} else{
    localStorage.setItem('language',language);
}

module.exports = { language: language }


/** WEBPACK FOOTER **
 ** ./src/js/languageCommon.js
 **/